import { TelegramIcon } from '../../../../../assets/icons/socialNetwork/Telegram';
import { SocialNetworkButton } from './SocialNetworkButton';

import './style.scss';

interface TelegramButtonProps {
  children: string;
  url: string;
  onClick?(): void;
}

export const TelegramButton = ({
  url,
  onClick,
  children,
}: TelegramButtonProps) => {
  return (
    <SocialNetworkButton
      icon={
        <TelegramIcon width={36} height={36} fill="#fff" outlined={false} />
      }
      url={url}
      onClick={onClick}
      className="telegram-button"
    >
      <span className="telegram-button__text">{children}</span>
    </SocialNetworkButton>
  );
};
